var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.registration)?_c('div',[_c('h2',{staticClass:"mb-4 fw-bold"},[_vm._v(" Registrazione ")]),_c('DynamicForm',{attrs:{"schema":_vm.registration.fields,"layout":_vm.registration.layout,"loading":_vm.loading},on:{"submitted":_vm.handleSubmit}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }